import axios from "axios";

export const loginServiceAdmin = async (mobile, password) => {
  return await axios.post(
    `${process.env.REACT_APP_BASE_URL}/api/auth/login`,
    mobile,
    password,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export const forgotPasswordService = async (mobile) => {
  return await axios
    .put(
      `${process.env.REACT_APP_BASE_URL}/api/auth/reset-password/request`,
      mobile,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(`Unable to login: ${error.message}`);
    });
};

export const resetPasswordService = async (code, mobile, password) => {
  return await axios
    .put(
      `${process.env.REACT_APP_BASE_URL}/api/auth/reset-password/reset`,
      code,
      mobile,
      password,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(`Unable to login: ${error.message}`);
    });
};
